import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Tooltip,
} from '@mui/material';
import { ExpandLess, ExpandMore, FiberManualRecordOutlined } from '@mui/icons-material';
import {
    listItemButtonStyle,
    listItemIconSelectedStyle,
    listItemIconStyle,
    listItemSelectedStyle,
    subListItemButtonStyle,
    subListItemSelectedStyle,
} from '../theme';

/**
 * A collapsible nav group with child links.
 */
export function NavGroup({ label, icon: Icon, isOpen, onToggle, miniDrawer, children }) {
    return (
        <Fragment>
            <ListItem disablePadding>
                <ListItemButton
                    sx={isOpen ? listItemSelectedStyle : listItemButtonStyle}
                    onClick={onToggle}
                >
                    <ListItemIcon sx={isOpen ? listItemIconSelectedStyle : listItemIconStyle}>
                        {miniDrawer ? (
                            <Tooltip title={label} placement="right" arrow>
                                <Icon />
                            </Tooltip>
                        ) : (
                            <Icon />
                        )}
                    </ListItemIcon>
                    {!miniDrawer && <ListItemText primary={label} />}
                    {!miniDrawer && (isOpen ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>
            </ListItem>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List>{children}</List>
            </Collapse>
        </Fragment>
    );
}

/**
 * A single nav link (top-level, not inside a collapsible group).
 */
export function NavLink({ label, icon: Icon, to, isActive, miniDrawer }) {
    return (
        <ListItem disablePadding>
            <ListItemButton
                sx={isActive ? listItemSelectedStyle : listItemButtonStyle}
                component={Link}
                to={to}
            >
                <ListItemIcon sx={isActive ? listItemIconSelectedStyle : listItemIconStyle}>
                    {miniDrawer ? (
                        <Tooltip title={label} placement="right" arrow>
                            <Icon />
                        </Tooltip>
                    ) : (
                        <Icon />
                    )}
                </ListItemIcon>
                {!miniDrawer && <ListItemText primary={label} />}
            </ListItemButton>
        </ListItem>
    );
}

/**
 * A sub-item link inside a collapsible group.
 */
export function NavSubItem({ label, to, isActive, miniDrawer }) {
    return (
        <ListItem disablePadding>
            <ListItemButton
                sx={isActive ? subListItemSelectedStyle : subListItemButtonStyle}
                component={Link}
                to={to}
            >
                <ListItemIcon>
                    {miniDrawer ? (
                        <Tooltip title={label} placement="right" arrow>
                            <FiberManualRecordOutlined fontSize="small" />
                        </Tooltip>
                    ) : (
                        <FiberManualRecordOutlined fontSize="small" />
                    )}
                </ListItemIcon>
                {!miniDrawer && <ListItemText primary={label} />}
            </ListItemButton>
        </ListItem>
    );
}
